import React from 'react'
import { browserHistory } from 'react-router'

import AddBankAccountForm from '../../components/Billing/AddBankAccountForm';
import EditBankAccountForm from '../../components/Billing/EditBankAccountForm';
import { billing } from '../../core/controllers/Billing';

export default class BankAccount extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            status: '',
            created: null,
            bank: null
        }
    }

    componentDidMount() {
        var self = this;
        if (!this.props.bankId) {
            return;
        }

        billing.getBankAccount(this.props.bankId, function(response) {
            const bank = response.data.bank;
            const property = response.data.property;
            self.setState({
                status: bank.status,
                created: bank.date,
                bank: bank,
                property: property
            });
        });
    }

    render(){
        const status                    = this.state.status;
        const created                   = this.state.created;
        var bankAccountName = ""
        if (this.state.bank) {
            bankAccountName = this.state.bank.accountName
        }

        return (
            <div class="col-md-12">
                <div class="row">
                    <span class="go-back go-back-left-side" onClick={browserHistory.goBack}><i class="icon-arrow-left"></i></span>
                </div>
                <div class="row">
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">{this.props.bankId ? (bankAccountName) : ("Add a Bank Account")}</span>
                        </div>
                        {status == 'PENDING' && (
                        <div class="row">
                            <span class="red-sub-page-header-banner">
                                PENDING VERIFICATION
                            </span>
                        </div>
                        )}
                        {created != null && (
                        <div>
                            <div class="row">
                                <span class="sub-page-header-submit-title">
                                    Date Created
                                </span>
                            </div>
                            <div class="row">
                                <span class="sub-page-header-submit-date">
                                    {moment.utc(created).local().format('DD MMM YYYY, h:mm A')}
                                </span>
                            </div>
                        </div>
                        )}
                    </div>
                </div>
                <div class="card">
                    <div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        {this.props.bankId ? (
                        <div>
                            {this.state.bank && (
                            <EditBankAccountForm bank={this.state.bank} property={this.state.property} />
                            )}
                        </div>
                        ) : (
                            <AddBankAccountForm />
                        )}
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/BankAccount/BankAccount.jsx